const jwt = require("jsonwebtoken");
import strings from "@/strings";

export default (context) =>{
   try {

      let contexteSSR = context.ssrContext ? context.ssrContext: context
      if ( contexteSSR.target && contexteSSR.target == 'server') {
         let url = contexteSSR.url
         const permissionName = url.includes('/admin/')? url.replace('/admin/', ''): url
         const routePermissions = strings.rolePermissions[permissionName]
         if (!context.$cookiz.get('access_token')) {
            throw ('user is not login')
         }
         const roles =  context.$cookiz.get('access_token') ?
               jwt.verify(context.$cookiz.get('access_token'),context.env.COOCKIES_SECRET_KEY).resource_access['marketplace-frontend'].roles
                  : null
         if ((routePermissions && roles && !routePermissions.every(route => roles.includes(route)))) {
            return context.redirect('/')
         }
      }
   } catch (error) {
      return context.redirect('/login')
   }

}

